import { ICalltracking } from './types';

export const defaultState: ICalltracking = {
  isAvailable: false,
  isEnabled: false,
  isCompulsory: false,
  periods: [],
  services: [],
  incompatibleServices: [],
  isAdditional: false,
  calltrackingPhoneSubstitutionsCount: null,
  selectedPeriodId: null,
};
